<style lang="scss" scoped>
::v-deep .issuu-wrapper {
    @apply flex flex-1 h-full;

    > div {
        padding-top: 0 !important;
        height: auto !important;
        @apply flex flex-1;

        iframe {
            @apply flex-1;
        }
    }
}
</style>

<template>
    <div>
        <button class="btn btn--primary btn--outline" @click="open">
            {{ campaignCta }}
        </button>
        <portal v-if="isOpen" to="modal">
            <div class="fixed inset-0 z-50 flex flex-col items-center justify-center">
                <div @click="close" class="absolute inset-0 bg-gray-800 opacity-[.64]"></div>
                <div class="absolute inset-0 w-[90vw] h-[90vw] max-w-[90vh] max-h-[90vh] sm:w-[90vw] sm:h-[73.6363636364vw] sm:max-w-[110vh] sm:max-h-[90vh] md:w-[90vw] md:h-[62.3076923077vw] md:max-w-[130vh] md:max-h-[90vh] bg-gray-300 text-gray-800 m-auto flex">
                    <div class="p-[20px] sm:p-[40px] flex flex-1 flex-col">
                        <div class="absolute top-[18px] right-[18px] cursor-pointer select-none text-gray-400 hover:text-gray-800" @click="close"><span v-html="svg('x')" /></div>
                        <h3 class="text-gray-900 flex-shrink-0 font-bold mb-sm sm:mb-md">{{ campaignTitle }}</h3>
                        <div class="relative flex-1 w-full flex">
                            <div class="issuu-wrapper">
                                <slot></slot>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </portal>
    </div>
</template>

<script>
export default {
    name: 'issuu-modal',

    props: {
        campaignCta: {
            type: String,
            required: true,
        },
        campaignTitle: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            isOpen: false,
        };
    },

    methods: {
        close() {
            this.isOpen = false;
        },
        open() {
            this.isOpen = true;
        },
    },
};
</script>
